import type { QueryEntity } from '@/sections/insights/queryBuilder/entities/types';

import { adObjectEntity } from './index';

/**
 * ADIssuancePolicy entity - alias of ADObject
 * Represents Active Directory Issuance Policy objects
 */
export const adIssuancePolicyEntity: QueryEntity<unknown> = {
  ...adObjectEntity,
  primaryLabel: { actual: 'ADIssuancePolicy', display: 'AD Issuance Policy' },
  alias: 'ADObject',
};
